import api from './api'

export interface SlaRule {
    id: number
    enabled: boolean
    title: string | null
    from_status: string
    from_status_label: string
    hours: number
    minutes: number
    to_status: string | null
    to_status_label: string | null
    create_task: boolean
    task_title: string | null
    task_text: string | null
    sort_order: number
    updated_at: string | null
}

export interface SlaStatusGroup {
    group: string
    reasons: { code: string; label: string }[]
}

export type SlaRulePayload = Partial<Omit<SlaRule, 'id' | 'from_status_label' | 'to_status_label' | 'updated_at'>>

// Правила SLA по статусам CRM Wiseway. Доступны тем же ролям, что и остальные
// настройки: «Админ ЛПЕ» и «Админ разработки».
export const slaRulesApi = {
    getStatuses: () => api.get<{ groups: SlaStatusGroup[] }>('/sla-rules/statuses'),

    getRules: () => api.get<SlaRule[]>('/sla-rules'),

    createRule: (data: SlaRulePayload) => api.post<SlaRule>('/sla-rules', data),

    updateRule: (ruleId: number, data: SlaRulePayload) => api.put<SlaRule>(`/sla-rules/${ruleId}`, data),

    deleteRule: (ruleId: number) => api.delete(`/sla-rules/${ruleId}`),
}
